import type { CollectCalculation } from '@/integrations/faturamento/client';

export interface CollectLabelNames {
  material?: string | null;
  packaging?: string | null;
}

/**
 * Rótulo de uma regra do "Cálculo aplicado": "Material · Embalagem" quando algum dos nomes resolve;
 * senão o rótulo que veio do serviço (o nome da regra, que é interno e cru para o gerador).
 */
export function ruleLabel(fallback: string, names: CollectLabelNames): string {
  const composed = [names.material, names.packaging].filter(Boolean).join(' · ');
  return composed || fallback;
}

/**
 * O faturamento-api devolve `material_id`/`packaging_id` da coleta no topo da memória de cálculo e
 * não conhece os nomes (não lê o catálogo de outro serviço). O portal já carrega o catálogo do
 * musa-agreements; é com ele que o rótulo vira "Óleo Alimentar · Bombona", como sempre foi na tela.
 */
export function withCollectLabels(
  calculation: CollectCalculation,
  materialNamesById: ReadonlyMap<number, string>,
  packagingNamesById: ReadonlyMap<number, string>,
): CollectCalculation {
  const names: CollectLabelNames = {
    material: calculation.material_id != null ? materialNamesById.get(calculation.material_id) : undefined,
    packaging: calculation.packaging_id != null ? packagingNamesById.get(calculation.packaging_id) : undefined,
  };
  if (!names.material && !names.packaging) return calculation;

  return {
    ...calculation,
    rules: calculation.rules.map((rule) => ({ ...rule, label: ruleLabel(rule.label, names) })),
  };
}
